module.exports = __webpack_public_path__ + "static/media/Extruded tooth4.091ae6e0.png";